module.exports = __webpack_public_path__ + "img/menuclose.41dacf3a.svg";